import router from '@/router';
import { useAuthStore } from '@/store/auth';

const routes = [
  {
    path: '',
    meta: {
      public: true,
    },
    component: () => import('@/layouts/FullPage'),
    children: [
      {
        path: '',
        redirect: 'login', // Redirect if no id
      },
      {
        path: 'login',
        name: 'login',
        beforeEnter: (to, from, next) =>
          useAuthStore().resolve({
            to,
            next,
            $router: router,
          }),
        component: () => import('@/views/public/Login'),
      },
      {
        path: 'logout',
        name: 'logout',
        component: () => import('@/views/public/Logout'),
      },
    ],
  },
];

export default routes;
